import type { ReactElement } from 'react';
import { useMemo } from 'react';

import { styled } from '../../../../../styled';
import { Theme } from '../../../../../theme/interface/detailed';
import { truncFilename } from '../../../../../utils/truncFilename';

const Component = ({ filename, className }: { className: string; filename: string }): ReactElement => (
	<div title={filename} className={className}>
		{useMemo(() => truncFilename(filename, 15), [filename])}
	</div>
);

export const Filename = styled(Component)(({ theme }: { theme: Theme }) => theme.allSettings.attachments.filename);
